export const LISTING_BUILDER_ITEM_ID = 'MS';
